import { achievementsGQL } from "@onmo/graphql/graphql";
import { useQuery } from "@apollo/client";
import { useCallback } from "react";
import { getDifferentAchievements } from "../models/achievement";
import { PRODUCT_QUERY } from "../constants/achievement";

export const useFetchNewAchievement = () => {
  const newAchievements = useQuery(achievementsGQL, { skip: true });
  const fetchNewAchivement = useCallback(async () => {
    const achievementsBefore = await newAchievements.client.query({
      query: achievementsGQL,
      variables: { input: { products: PRODUCT_QUERY } },
      fetchPolicy: "cache-only",
    });
    const achivementAfter = await newAchievements.client.query({
      query: achievementsGQL,
      variables: { input: { products: PRODUCT_QUERY } },
      fetchPolicy: "network-only",
    });
    return getDifferentAchievements(
      achievementsBefore.data.me.achievements.items,
      achivementAfter.data.me.achievements.items,
    );
  }, [newAchievements]);

  return { fetchNewAchivement };
};
